// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';
import {addressTypeLabels} from '../../enum/address-type';

export const AddressLabels = t.struct({
    addressType: t.String,
    addressLine1: t.String,
    addressLine2: t.String,
    city: t.String,
    countryCode: t.String,
    postalCode: t.String,
    stateCode: t.String,
    countyName: t.maybe(t.String)
}, {
    defaultProps: {
        addressType: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        countryCode: '',
        postalCode: '',
        stateCode: '',
        countyName: null
    },
    name: 'AddressLabels'
});

AddressLabels.prototype.getAddressLabel = function () {
    return {
        [addressTypeLabels.MAILING]: 'labels.POSTAL_ADDRESS',
        [addressTypeLabels.PHYSICAL]: 'labels.DELIVERY_ADDRESS'
    }[this.addressType];
};
